
/**
 * directives.slider Module
 *
 * Description
 */
var app = angular.module('directives.sliderWidgets');
app.directive('sliderWidgets', ['$window', 'History', function ($window, History) {
    return {
        templateUrl: './app/directives/sliderWidgets/index.html',
        controller: [
            '$scope',
            '$element',
            'Cards',
            function ($scope, $element, Cards) {
                $scope.cards = Cards;
                $scope.cards.getCards();

                var sliderWidgets = {
                    serviceWidth: 270,
                    itemCounts: 3,
                    currentService: 0,
                    service: [],
                    prevService: function () {
                        if (sliderWidgets.service[0].left < 0 && sliderWidgets.itemCounts == 2) {
                            sliderWidgets.service = [
                                {
                                    left: sliderWidgets.serviceWidth
                                },
                                {
                                    left: 2 * sliderWidgets.serviceWidth + 270
                                },
                                {
                                    left: (3 * sliderWidgets.serviceWidth) + 540
                                }
                            ];
                        }
                    },
                    nextService: function () {
                        if (sliderWidgets.service[0].left > 0 && sliderWidgets.itemCounts == 2) {
                            sliderWidgets.service = [
                                {
                                    left: -(sliderWidgets.serviceWidth + 270)
                                },
                                {
                                    left: sliderWidgets.serviceWidth - 125
                                },
                                {
                                    left: (2 * sliderWidgets.serviceWidth) + 50
                                }
                            ];
                        }
                    },
                    setActiveCard: function (cardId) {
                        Cards.activeCard = cardId;
                    }

                };

                $scope.sliderWidgets = sliderWidgets;

                var widgetHistory = {
                    list: [],
                    loading: true,
                    getHistory: function () {
                        History.getPeriod().then(function () {
                            var tmp = History.peridoHistory;

                            if (tmp.length > 2) {
                                tmp = tmp.splice(0, 2);
                            }

                            widgetHistory.list = tmp;
                        }, function () {
                            alert('Возникла ошибка при загрузке истории платежей.')
                        }).finally(function () {
                            widgetHistory.loading = false;
                        });
                    }
                };

                $scope.widgetHistory = widgetHistory;

                var w = angular.element($window);
                $scope.$watch(function () {
                    return {
                        'height': w[0].innerHeight,
                        'width': w[0].innerWidth
                    };
                }, function (newValue, oldValue) {
                    sliderWidgets.itemCounts = newValue.width <= 1400 ? 2 : 3;
                    if (sliderWidgets.itemCounts == 3) {
                        sliderWidgets.service = [
                            {
                                left: 0
                            },
                            {
                                left: 305
                            },
                            {
                                left: 610
                            }
                        ];
                    } else {
                        sliderWidgets.serviceWidth = Math.floor((newValue.width - 700) / 3) < 120 ? 120 : Math.floor((newValue.width - 700) / 3);
                        sliderWidgets.service = [
                            {
                                left: sliderWidgets.serviceWidth
                            },
                            {
                                left: 2 * sliderWidgets.serviceWidth + 270
                            },
                            {
                                left: (3 * sliderWidgets.serviceWidth) + 540
                            }
                        ];
                    }
                }, true);

                widgetHistory.getHistory();

                w.bind('resize', function () {
                    $scope.$apply();
                });
            }]
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderWidgets/directive.js
 ** module id = 233
 ** module chunks = 1
 **/